import { ModuleWithProviders, NgModule } from '@angular/core';

import { SharedMetaModule } from './shared-meta';
import { services as SERVICES } from '@shared/services';
import { ApiServicesModule } from '@cakeiteasy/order-process';

@NgModule({
  exports: [
    SharedMetaModule,
    ApiServicesModule,
  ],
  providers: []
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SERVICES.ProductsApiService,
        SERVICES.BakeriesApiService,
        SERVICES.LayoutContextService,
        SERVICES.EditingCakeSessionService,
        SERVICES.ContextProviderService,
        SERVICES.NotFoundService,
        SERVICES.KeywordsFetcherService,
        SERVICES.SsrResponseManager,
      ]
    };
  }
}
